<template>
    <div>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company v-model="model.company" :min-length="0"></company>
        </div>

        <div class="form-group">
            <label class="control-label">API Type</label>
            <input class="form-control" type="text" v-model="model.api" readonly>
        </div>

        <div class="form-group" v-show="model.api === 'Asana'">
            <label class="control-label">Change Asana Project</label>
            <asana-project-list v-model="model.data"></asana-project-list>
        </div>

        <div v-show="model.api === 'Custom'">
            <div class="form-group">
                <label class="control-label">Name</label>
                <input class="form-control" type="text" v-model="model.name">
            </div>

            <div class="form-group">
                <label class="control-label">URL</label>
                <input class="form-control" type="text" v-model="model.url">
            </div>
        </div>

        <div class="buttons">
            <button @click.prevent="store" type="submit" class="btn btn-success btn-sm">
                <span>Save</span>
            </button>
        </div>
    </div>
</template>
<script>
    import AsanaProjectList from "../../components/asana-project-list";
    export default {
        components: {AsanaProjectList},
        data() {
            return {
                model: {
                    public_id: 0,
                    company: '',
                    name: '',
                    api: 'Custom',
                    data: {}
                },
            }
        },
        created() {
            this.$eventHub.$on('setExternalLinks', this.setData);
        },
        methods: {
            setData(data) {
                this.model = this.$setData(data, this.model);
            },
            store() {
                this.$store('/api/links/store', this);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>